import { configureStore } from "@reduxjs/toolkit";
import MRSlice from "./slices/MRSlice";
import AdminDashboardSlice from "./slices/AdminDashboardSlice";
import AdminDataSlice from "../redux/slices/AdminSlices/AdminDataSlice";
import ScheduleACallSlice from "./slices/ScheduleACallSlice";
import authSlice2 from "../redux/slices/AuthSlice2";
import GuestSlice from "../redux/slices/GuestSlice";
import snackbarReducer from "../redux/slices/SnackbarSlice";
import dashboardSlice from "../redux/slices/UserSlices/DashboardSlice";
import localBusinessSlice from "../redux/slices/UserSlices/LocalBusinessSlice";
import helperSlice from "../redux/slices/HelperSlice";
import hetamapSlice from "../redux/slices/UserSlices/HeatmapSlice";
import addonSlice from "../redux/slices/UserSlices/AddonsSlice";
import billingSlice from "../redux/slices/UserSlices/BillingSlice";
import historySlice from "../redux/slices/UserSlices/HistorySlice";
import AdminHelperSlice from "../redux/slices/AdminSlices/AdminHelperSlice";
import GBPSlice from "../redux/slices/AdminSlices/GBPSlice";
import publicSlice from "../redux/slices/UserSlices/PublicSlice";
import TeamsSlice from "../redux/slices/TeamsSlice";
import adminBusinessSlice from "../redux/slices/AdminSlices/AdminBusinessSlice";
import categorySlice from "../redux/slices/CategorySlice";
import MapCheckInDashboardSlice from "../redux/slices/MapCheckInDashboardSlice";
import widgetSlice from "../redux/slices/WidgetSlice";
import momentSlice from "../redux/slices/MomentSlice";
import AgencySlice from "../redux/slices/AgencySlice";
import AdminHeatmapSlice from "../redux/slices/AdminSlices/AdminHeatmapSlice";
import EjectSlice from "../redux/slices/EjectSlice";
import workspaceReducer from "../redux/slices/WorkspaceSlice";
import adminAudioReducer from "../redux/slices/AdminSlices/AdminAudioSlice";
import adminCrmImportReducer from "../redux/slices/AdminSlices/AdminCrmImportSlice";
import resellingSlice from "../redux/slices/UserSlices/ResellingSlice";
import onboardingSlice from "../redux/slices/UserSlices/OnboardingSlice";
import reviewWidgetReducer from "../redux/slices/ReviewWidgetSlice";
import photoGalleryWidgetReducer from "../redux/slices/PhotoGalleryWidgetSlice";
import reportBuilderReducer from "../redux/slices/ReportBuilderSlice";

export const store = configureStore({
  reducer: {
    MRState: MRSlice,
    AdminDashboardState: AdminDashboardSlice,
    adminData: AdminDataSlice,
    adminheatmap: AdminHeatmapSlice,
    ScheduleCallState: ScheduleACallSlice,
    auth: authSlice2,
    guest: GuestSlice,
    snackbar: snackbarReducer,
    dashboard: dashboardSlice,
    localBusiness: localBusinessSlice,
    helper: helperSlice,
    heatmap: hetamapSlice,
    addon: addonSlice,
    billing: billingSlice,
    reselling: resellingSlice,
    history: historySlice,
    adminHelper: AdminHelperSlice,
    gbp: GBPSlice,
    public: publicSlice,
    teams: TeamsSlice,
    adminBusiness: adminBusinessSlice,
    category: categorySlice,
    mapCheckIn: MapCheckInDashboardSlice,
    widget: widgetSlice,
    reviewWidget: reviewWidgetReducer,
    photoGalleryWidget: photoGalleryWidgetReducer,
    reportBuilder: reportBuilderReducer,
    moment: momentSlice,
    agency: AgencySlice,
    eject: EjectSlice,
    workspace: workspaceReducer,
    adminAudio: adminAudioReducer,
    adminCrmImport: adminCrmImportReducer,
    onboarding: onboardingSlice,
  },

  //   middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
